import api from "../../../services/api";

/**
 * verveBillingService - Handles multiple Bank and Digital payment accounts.
 */

// Banks
export const getBanks = () => api.get("/verve-kitchens-billing/banks");
export const createBank = (data) => api.post("/verve-kitchens-billing/banks", data);
export const updateBank = (id, data) => api.patch(`/verve-kitchens-billing/banks/${id}`, data);
export const deleteBank = (id) => api.delete(`/verve-kitchens-billing/banks/${id}`);

// Digital Payments
export const getDigitalPayments = () => api.get("/verve-kitchens-billing/digital");
export const createDigitalPayment = (data) => api.post("/verve-kitchens-billing/digital", data);
export const updateDigitalPayment = (id, data) => api.patch(`/verve-kitchens-billing/digital/${id}`, data);
export const deleteDigitalPayment = (id) => api.delete(`/verve-kitchens-billing/digital/${id}`);
